document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.about-series-img-swiper')) {
    var aboutSeriesImgSwiper = new Swiper(".about-series-img-swiper", {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          var slide = this.slides[index];
          var attribute = slide.getAttribute('data-series');
          return '<span class="' + className + ' solution-swiper-pagination">' + attribute + '</span>';
        },
      }
    });
  }

  if (document.querySelector('.about-recommended-swiper')) {
    // initAboutRecommendedSwiper();
    var aboutRecommendedSwiper = new Swiper(".about-recommended-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    });
  }
});

// window.addEventListener('resize', function() {
//   if (document.querySelector('.about-recommended-swiper')) {
//     initAboutRecommendedSwiper();
//   }
// });

function initAboutRecommendedSwiper() {
  var clientWidth = document.documentElement.clientWidth;
  if (clientWidth > 767) {
    // pc
    var aboutRecommendedSwiper = new Swiper(".about-recommended-swiper", {
      slidesPerView: 3,
      spaceBetween: 30
    });
  }else {
    var aboutRecommendedMobSwiper = new Swiper(".about-recommended-swiper", {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      initialSlide: 1
    });
  }
}